import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ModalAlertasComponent } from "./Shared/Ui/landig/Alerts/modal-alertas/modal-alertas.component";
import { NotificationsComponent } from "./Shared/Ui/landig/notifications/notifications.component";

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, ModalAlertasComponent, NotificationsComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'SertriadWeb';
}
